import SectionHeading from "@/components/common/SectionHeading";
import { FAQS } from "@/lib/data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQSection() {
  return (
    <section className="py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="Answers to what most people ask us."
          sub="Still curious? Book a 30-minute free consultation and we'll answer everything specific to your hiring needs."
          align="center"
        />
        <Accordion type="single" collapsible className="mt-14 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="glass rounded-2xl px-5 border-white/5 data-[state=open]:border-[#10B981]/30"
            >
              <AccordionTrigger className="font-poppins text-white text-left text-base sm:text-lg py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="font-inter text-white/60 pb-5 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}
